import * as React from "react";
import styled from "styled-components";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { FormInput, InputWrap, LeadingIcon } from "../views/login.form.c";

const ToggleButton = styled.button`
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6b7270;

	&:hover {
		color: #4b4f5e;
	}
`;

interface PasswordInputProps {
	id?: string;
	name: string;
	placeholder: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	disabled?: boolean;
	tabIndex?: number;
	autoComplete?: string;
	showLeadingIcon?: boolean;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
	id,
	name,
	placeholder,
	value,
	onChange,
	required,
	disabled,
	tabIndex,
	autoComplete,
	showLeadingIcon = true,
}) => {
	const [visible, setVisible] = React.useState(false);
	return (
		<InputWrap>
			{showLeadingIcon && (
				<LeadingIcon aria-hidden="true">
					<FaLock />
				</LeadingIcon>
			)}
			<FormInput
				id={id}
				type={visible ? "text" : "password"}
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				required={required}
				disabled={disabled}
				tabIndex={tabIndex}
				autoComplete={autoComplete}
				hasLeadingIcon={showLeadingIcon}
				hasTrailingIcon={true}
			/>
			<ToggleButton type="button" onClick={() => setVisible(!visible)} tabIndex={-1} aria-label={visible ? "Hide password" : "Show password"}>
				{visible ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
			</ToggleButton>
		</InputWrap>
	);
};
